import { useState } from 'react';
import PropTypes from 'prop-types';
import { useForm, FormProvider } from 'react-hook-form';
import { setPreferences } from 'services/UserAccountService';

export const PreferencesForm = (props) => {
  const { currentPreferenceModel } = props;
  const [isBusy, setIsBusy] = useState(false);
  const [successMessage, setSuccessMessage] = useState();
  const [errorMessage, setErrorMessage] = useState();
  const { register, handleSubmit } = useForm({
    defaultValues: {
      emailPreferences: currentPreferenceModel.EmailPreferences,
      asiaTopaEmailPreferences: currentPreferenceModel.ATEmailPreference,
      SMSUpdatePreferences: currentPreferenceModel.SMSUpdatePreference,
    },
  });

  const onSubmit = async (data) => {
    setIsBusy(true);
    setSuccessMessage(null);
    setErrorMessage(null);

    const userData = { ...currentPreferenceModel };

    if (data.emailPreferences) {
      userData.Request = 'undo_unsubscribe';
    } else {
      userData.Request = 'unsubscribe';
    }

    if (data.asiaTopaEmailPreferences) {
      userData.AsiaTopaPreference = 'Opt In 2020';
    } else {
      userData.AsiaTopaPreference = 'Opt-Out';
    }

    if (data.SMSUpdatePreferences) {
      userData.SMSPreference = 'Y';
    } else {
      userData.SMSPreference = 'N';
    }

    const result = await setPreferences(userData);

    if (result.SuccessVisible) {
      setSuccessMessage(result.SuccessMessage);
    } else if (result.ErrorVisible) {
      setSuccessMessage(result.ErrorMessage);
    }

    setIsBusy(false);
  };

  return (
    <FormProvider>
      <form
        name="userPreferenceForm"
        noValidate
        onSubmit={handleSubmit(onSubmit)}
        data-testid="preferences-form"
      >
        <div className="row">
          <div className="col-md-8 col-md-offset-1">
            <div className="form-group">
              <div className="input-container">
                <div className="custom-checkbox">
                  <input
                    type="checkbox"
                    id="userData.EmailPreferences"
                    name="emailPreferences"
                    data-testid="input-emailPreferences"
                    {...register('emailPreferences')}
                  />
                  <label htmlFor="userData.EmailPreferences" className="label-unbold">
                    Yes, Id like to be contacted by email and receive special offers, news, surveys
                    and exclusive information about upcoming performances.
                  </label>
                </div>
              </div>
              <br />
              <div className="input-container">
                <div className="custom-checkbox">
                  <input
                    type="checkbox"
                    id="userData.ATEmailPreference"
                    name="asiaTopaEmailPreferences"
                    data-testid="input-asiaTopaEmailPreferences"
                    {...register('asiaTopaEmailPreferences')}
                  />
                  <label htmlFor="userData.ATEmailPreference" className="label-unbold">
                    Yes, I'd like to be contacted by email and receive special offers, news and
                    exclusive information about the Asia TOPA program.
                  </label>
                </div>
              </div>
              <br />
              <div className="input-container">
                <div className="custom-checkbox">
                  <input
                    type="checkbox"
                    id="userData.SMSUpdatePreference"
                    name="SMSUpdatePreferences"
                    data-testid="input-SMSUpdatePreferences"
                    {...register('SMSUpdatePreferences')}
                  />
                  <label htmlFor="userData.SMSUpdatePreference" className="label-unbold">
                    Yes, I'd like to be contacted by SMS and receive information on donation
                    options, special offers, news, surveys and exclusive information about upcoming
                    performances.
                  </label>
                </div>
              </div>
              <br />
              <p>
                <b>
                  For further information about how we use and manage your personal information,
                  please read our <a href="/privacy-policy">Privacy Statement</a>.
                </b>
              </p>
            </div>

            <br />
            <p>
              <em>
                Note: if you have <strong>opted out</strong> of receiving emails, Arts Centre
                Melbourne will still contact you to deliver important information about your
                booking, such as cancellations, alterations to start time or changes to relevant
                acts.
              </em>
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-md-8 col-md-offset-1">
            {successMessage && (
              <div className="callout-row">
                <div className="callout-container callout-success">
                  <p>{successMessage}</p>
                </div>
              </div>
            )}

            {errorMessage && (
              <div className="callout-row">
                <div className="callout-container callout-error">
                  <p>{errorMessage}</p>
                </div>
              </div>
            )}

            <br />

            <button
              className="btn btn-primary"
              type="submit"
              disabled={isBusy}
              data-testid="save-button"
            >
              {isBusy ? 'Processing...' : 'Save'}
            </button>
          </div>
        </div>
      </form>
    </FormProvider>
  );
};

export const PreferencesFormSC = (props) => {
  const { sitecoreData } = props;
  return <PreferencesForm currentPreferenceModel={sitecoreData} />;
};

PreferencesForm.propTypes = {
  currentPreferenceModel: PropTypes.object.isRequired,
};

PreferencesFormSC.propTypes = {
  sitecoreData: PropTypes.object.isRequired,
};
